<template>

    <div class="page white_bg" data-notice="资讯页展示文章内容">

        <header class="pageHeader white_bg bottomBorderBBB" style="line-height: 46px;">
            <div class="borderLayout paddingH16">
                <div class="middleRegion">
                    <div class="westRegion" style="width: 60px">
                        <span class="icon leftAngleBracketIcon floatL" style="margin-top: 12px;" @click="back();"></span>
                    </div>
                    <div class="centerRegion alignCenter font18r primaryTextColor bold"
                         style="height: 46px; overflow: hidden">
                        {{title}}
                    </div>
                    <div class="eastRegion font14r alignRight" style="width: 60px">
<!--                        <router-link :to="{name : 'search'}">-->
<!--                            <i class="icon searchIcon" style="margin-top: 3px;"></i>-->
<!--                        </router-link>-->
                    </div>
                </div>
            </div>
        </header>

        <div class="body">

            <div class="categoryArea autoOverflow hiddenScrollbar">
                <div class="clearfix" :style="'width: ' + ((categoryList.length + 1) * 90) + 'px'">
                    <div class="categoryItem" :class="{active : activeCategory === ''}"
                         @click="changeCategory(null)">
                        推荐
                    </div>
                    <div class="categoryItem" :class="{active : catItem.id === activeCategory}"
                         v-for="catItem in categoryList" :key="catItem.id" @click="changeCategory(catItem)">
                        {{catItem.name}}
                    </div>
                </div>
            </div>

            <div class="paddingH8">

                <div class="paddingB20">
                    <bannerModule ref="bannerModule" version="4" categoryKey="NEWS_INDEX" />
                </div>

                <div class="articleList" style="margin-top: 30px;">
                    <div class="dataItem bottomBorderF5F5F5" v-for="dataItem in dataList" :key="dataItem.id"
                         style="margin-bottom: 20px;"
                        @click="viewItem(dataItem)">
                        <div class="titleArea color101010 font14r bold hiddenOverflow"
                             style="max-height: 48px; line-height: 24px;">
                            <strong class="marginR4">{{dataItem.title}}</strong>
                            <i class="icon newIcon relative" style="top: 6px;" v-if="isToday(dataItem.createTime)"></i>
                        </div>
                        <div class="font12r clearfix marginT20" style="line-height: 24px; padding-left: 10px; padding-bottom: 16px;">
                            <div class="floatL">
                                <img class="size24 circle fl marginR4" :src="dataItem.userImg">
                                <span class="font12r" style="color: hsla(219, 9%, 39%, 1)">
                                    {{dataItem.userName}}
                                </span>
                            </div>
                            <span class="color777 marginL16">{{formatDate(dataItem.createTime)}}</span>
                            <div class="fr orange" style="padding-right: 12px;">
                                <i class="icon eyeIcon fl marginR4"></i>
                                <!-- 浏览量：真实值+虚拟值 -->
                                {{dataItem.pv + dataItem.pvSham}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="alignCenter paddingV8" v-show="status === 'loading'">
                    <i class="icon spinner-loader"></i>
                </div>

                <div class="paddingV16 colorCCC font14r alignC"
                     v-show="status == 'ready' &&  dataList.length < 1">
                    暂无任何文章
                </div>

                <div class="paddingV16 alignCenter font14r colorCCC"
                     v-show="status=='ready' && pagination.current == pagination.totalPage"
                     :data-current="pagination.current" :data-total="pagination.totalPage || 0">
                    没有更多文章了
                </div>

                <div class="paddingV16 colorCCC font14r alignC"
                     v-show="status == 'error'">
                    加载数据失败
                </div>

            </div>


        </div><!-- end .body -->

        <bottomMenu ref="bottomMenu" activePath="/discover"/>

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';
import bannerModule from '@/components/ad/bannerModule4';
import bottomMenu   from '@comp/bottomMenu';

// config
import appConfig from '@/appConfig';

import categoryApi from '@/api/category';

// util
import appHelper        from '@/util/appHelper';
import dataMixedUtils   from "@/util/dataMixedUtils";
import timeHelper from "@util/timeHelper";
import consoleApi from "@comp/platformApi/consoleApi";
import externalApp from "@data/externalApp";

const config = {
    name : 'articleIndex',
    title : '资讯',
    description : '',
    apiConfig : {
        list : {
            url : 'portal/article/list',
            dataPath : 'data.rows',
            totalPagePath : 'data.totalPage',
            dataColumnMapping : {
                // userName : 'name''
            }
        }
    },
    demoTitleList : [
        '奥尔夫音乐课程春秋课新精选课程',
        '如何使运营的微信公众号活跃起来？',
        '做好这几点，让园区摆脱对名师的依赖'
    ]
};

export default {
    name: config.name,
    extends : shixunPagePart,
    components : {
        bannerModule,
        bottomMenu
    },
    data () {
        return {
            title : config.title,
            description : config.description,
            apiConfig : config.apiConfig,
            pageSize : 20,
            enableDataList : true,
            autoLoadDataList : appConfig.mode != 'demo',

            categoryList : [{
                id : '',
                name : '推荐'
            },{
                id : 'hot',
                name : '新闻热点'
            },],
            activeCategory : '',

            filters : {
                firstCategory : ''
            }
        }
    },
    methods : {
        // onLoadDataList() {
        //
        // },
        viewItem(dataItem) {
            appHelper.redirect(externalApp.oldShixun.baseUrl + 'html/article/detail.html?id=' + dataItem.id);
        },
        changeCategory(catItem) {
            if (!catItem)
            {
                this.activeCategory = this.filters.firstCategory = '';
            }
            else
            {
                this.activeCategory = this.filters.firstCategory = catItem.id;
            }
            this.reloadDataList();
        },
        isToday(timestamp) {
            return timeHelper.isToday(timestamp);
        }
    },
    mounted() {

        consoleApi.log('[article index] 文章列表页：')

        if (appConfig.mode == 'demo')
        {
            this.dataList = dataMixedUtils.array.buildDataList(8, (index) => {
                return {
                    id : index,
                    title : dataMixedUtils.array.getRandomItem(config.demoTitleList),
                    coverImg : appHelper.getRandomCoverImage(),
                    userHead : appHelper.getRandomCoverImage(),
                    createTime : new Date().getTime() - dataMixedUtils.number.getRandomInteger(1000 * 60 * 60 * 24 * 7)
                }
            });
        }
        else
        {
            categoryApi.loadList('ARTICLE', (data) => {
                this.categoryList = data;
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.searchIcon {
    width: 18px;
    height: 19px;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAmCAYAAABDClKtAAADVklEQVRYhcWYT4jVVRTHb00DNgYiuRUXuhAdH9zz+d6hgSf8RKQhGC3ih2U7CSIIhEJdBEK0qFaKKBptBLFoIWYgLRKhiGgSUjcTiFhBQfindPUGG2dczHvTnTu/9+b9Zt6fA2fx3r3nnM895/7uP+dKSJ7nA977ncAHkr6RdBuoAbPAbP33FUlHzewVYLCM/1ICrAM+BO40ANpRM5uS9CmwuZMwQ8CRMiAt9DNg3YqAJA0Dv7YI8kDSz5IuRnoV+LOFzUNJu5YFZGZjZjZV5BQ4I2lkCftNko4CfzSBe9s593SZDO0pcDIl6USWZavKDtB7f7g+mNTngbYcmFklzZCZ/SbJl4WJpVqtrgV+KfgQ9rY0BNYAtxPDyeVkp0WMr9Kv08w2NTWQ9EmaoU4CRXF+TOJczrLsmUUdQwjrC+bQikrWTEZHR59N1ztJe4roTyRQx7oB1BBgHzATxbuxoEOWZauSyf2wG2UrALuWZOv/ykh6NcnSmW4D1eO+k0AdiomPJ40tF8ZOCjAdxf4hJv4uLl2vgOpQ16PYNefcU42G36MsXe0x1KW4SiGE9Y2GeD5d6THUuTi+937DIihJX/cTysxwzjlnZv/2sXyfNytffGb6q5dQki7HUPPrY0I7MzIy8nyvoIC/o9i34oYDSQrf6wWQmW1PPrKT843e+y3JZO/JvJJ0MYF6eUEH4Ke4hJJe6iYQc7ej/+KFc9HxpWD/u9lNKEnfJtU5uKhTnucD9ZtIvGZ80SWgQ8mxpQasKexsZi8k2ZqR9H4ngUIIe4FHSZZeX2oUBxOwaeBUJ4CAN1Mg4Fye5wNLGQ5KOp0YzgITK1m/zOy8pOnE57VKpbK63RENAV8WgNWAC+3CjY+PD5nZSeBBga9Z4D5l3hiAQeDjJs4eAzfM7Kyk/ZKGG+q9fw04Bkyw8ADXTO9577e0Deacc2b2YrIVrERrkvYD/yT/3w0hbC0FVqlUVgPvxqeJZehH1Wp1rXPzO8j9FEzScCkw5+ZuPSGEcUnniR7KWuglM3sjy7LnUl8hhK3AvaT/HWBbabCG5Hk+AGwMIYxJ2i3pLe/97hDCmJlVXBsvKvWnprspWN2+fwJsKwD7vq9Qzs299LDwGj/Zbybn3DzYBDAJ7HgCwHW6Z9xb1m4AAAAASUVORK5CYII=');
}
.eyeIcon {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAE20lEQVRoQ+1YW2wUZRQ+Z3ZmtmgEYgPEGismYIIQxNTdhbRoC0YJAm13N000xsT4It4Sow/G4GPlRU003h58MF5e6u5CITQpEQpakd21Yoj1wUuQKl6IlYuVbOd2PP/IbnrZuXW3EpKZp3b2nO8/5zvff/7zD8JV/uBVHj+ECVzpCoYVCCtQIwOhhGoksGb3sAI1U1gjQFgBQSANLW8w/loSB8A2i7ANkZoIoJHZWQKE/IrG+e9xfveLRPAFIH0mLziXx60/TNZYgLmPEjS49lptIroNSOrhgO/n4KOBgiEocUIDIMHHqmLsw+0jlwL5XzYOLCEaWBE1Ll3/NC++CxAXzmXR2T50HhF7ZWPidewZ1YJgBkrAyMS2m4hvIuBNLosMI0I/ofmpAsZ3wk4H+Va0cCOB1M3/tjr5EtDPEaIn5HRxv98kfCVAfRsW6BHzFZbJTsfFCb7nwB9WU/njbotr2cR6InifbVc62hG9ozSefQY7fip5JeKZAOXWLtWthsMsl9XOYPSNgtCOycK414L2pheY1HCICVnjksSoIpU2YfLkWTdM1wSor6VZkyJHWJ+3uDB/RlWgBTvzf5RtJjOxhwCkLma5jdk2+H0ewNoTTRc/LNtQf2KZpsMI29zojE2nVMtsx56RMScbxwQ4+EUc/EkOvtmVAbTalWTxqM1s/x1NuqGKIDscfIYU03oQe4q/23sjm+jgZnDYDZ+IxtSIdjt2f32+ml3VBJg11HOJg+xwj4ckhljzm8o2rO9ht01q2xEdUtOFCq6WjQspVTCqrcdJHFRThS1cLc53+lM1AT0be5Y7xsueeibrcTVdfFvYcSCPciDvevrYBtYjaqr4nu2Xie0ElN7y8kOwnlNSRW4kHgkI6ehSZMxPjyey1rCuRwXkZCZxgBna6hWIXQSgA9FUYZvttzdxG5pgY7g+RBcUy7yZ98OFqXazKsCB7OZAnvfCE78rprG4DMjyEZt4qR8/TuA3TqDJTkYQFpGr6nsmFutndzSVf8E9gWy8lw+qaUZOQSmyvBA7P//blkI2ITbmssAJ9LdepxvGRV9+RL3RdGGXawKXJXSaJbTIC5QisDralf/2PwnFB7lj3evlM1NClFu/SieyMTwkdJEl1OwpIQEyl01sZOPdFmDOKw7xu4TQJSfz/Xbl6r2JbYa4jWq5+ABLaYtHQNPbaCb+CVdus5sP63+Q9V/BZemJc8Dp3LChRBtl6dxXDdf5INuzbrFmRU+wwXK3gHDqQZZtuYEHt49cAhpSZHigfGrrudjdRNIR94ThtCpNrgt0kJUBxcmq6QpPl3MeJXgCJY0vNWKU2DtrlDDgKybI7kbVHmb+lKrobdh54lcnG3/DXJ0GrwoxvgfE0uaahrnKgmKclsxXWd+PObMVaJz+gM+aFY7Sqec4PXURI3vnDhOkN3xdaMg6qpjyj3DNBOl6dCVS5C6WRJLHjQ2OJIgLDVhPyqkv9/npZsLGU0IzgewrZanxKbLoRT/jhr9A+EpJ8JJs/fPavF4ppwZTt0s9Wn2qau3/3y71VbtF+bMK4UY+zFpnfFYh/qzyp/1ZhfCMBHQMJBqWG84dv6KfVfxJY/6tAu+B+Q8p2AphAsH4qr91WIH6cxoMMaxAML7qbx1WoP6cBkMMKxCMr/pb/wvaXBxPiPCT6wAAAABJRU5ErkJggg==');
}
.newIcon {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAFGUlEQVRoQ+1YW0xcVRTd55x7L1IH0AZtRGYiUR5TtNbyYZpUqzVNMb6if5r40Q9sTRr5URuDGhvro00aU02qrSbaH2OsmuIjimlE46vGD20rMlCMCQNotAXKI8h9bdcdmGFmGMiUewm0mZOQ4bz23mutvfdhEHSBD3GBx08FAEutYEGBggI+GSikkE8CfV8vKOCbQp8GLj4FmEh0raJrlK5FbPzuk6BAritBrkt2T12cBrINZgQYW0VVXKQfESQaAvEctBGmz4tGzYeqhmk4aToFAMyrWMQ4iYXVQfsN1B7zwbq4tX0WgNMRo94h+i1QZ4tgjImtul7rUhBteeZTCnRfre5ylfp0EXwGblJzzerr+qgnA0BnRN0jSH0cuLdFMMiOWRvtp+6LHADz68z8vhS0joXcl04k1g8T8ztCyvas9eOSxH6X3b9TRSbFWmTqK4LpRTTDr1iKNhJCZd5zG4lpUkjxBc4WZYjGzn3EchNJ0Zxcz0sBZvfxaNxOBI7u9Ds+oikDRLuiveZzWEfzmhrM9FJd3GzprqQKl7TqbAA48RaKr6kzrH8phNicCpL5BLoKQHp+9GMAcEfa3insrYmFjVZU673nDSDE9gF7ksrMIrWepfpobgD8PYLbEAtrLQhgVzbDUwipHwArEeRjOLN/BjjvQ5BPdJVTiIq1ZhLy+RR4qLaCzd1jUh/G22ScNwAxYR+iYn0vHDwKx7/AcYIp0J6hgJceNXHzGZz5D470jBRIm7BLa4QwzyKW/hkASB+HRqXkMqTXCJH8LrmnHF7Pwq1wpfowI+XyKWIvhaYBDGmOVWUrdRMJ1ZoLAHrzduXQT64SADnPcN2ddX323s6I0eE9mKglW4tbITtiPAVWDCj0bFdEH0vUAfOZ2rh1JeaHMX944QBWGCMCBQtjW5MqZCsAANuivdahXKF3RvRtUOWN6UL5Gmrejtp5GfOd0LIdqbcJdfEjANnYuyVVI8xvw2cTAAwCQKkvAGDDlcKqdkitxlvxSS4ARZbVNqkbW3OAaEBwd08DcEodq3RU09YxyW9htuWSUfvAZIk+CJsOABSjjp4UQr4gXOcBYjHCSqKwM0feXSiRQlAgkTbM70Xj1oOeCkyiNb0LeekmXXGMlfh13hTCphdYTZ9zFMwOoXY2o+VGhFQfePckuxsdh2zSRHuZbV1+Tul70LF2BALAMyJsM0pSVaGobs5oo8zvOkgxFdHP4FTJfCCQbm8i3R4BgFdreq1mEHIQKdY0pZD7dG3c3tMVNo6gHu5HrQxAvasCA4BCO5owHNa24I1oS74DUGc8xFZkQmoNDslmyBVKOkUAl6Gt3pgKYrqdnl5JpdWDNIIeH0ePr5wCQG2w3xiroFpSegnu/ZyLjAWlUCogh9fW9lsnvHn6QwbvPzgT1pb6fwldZGZ0Vmq3zXqx0U6jfeapRKCaEUueBhFjqIMygHYBbDeA4V2ZPfICADb+QFB/gYUN6Sbw4vZi/c9ESgmxMXOPx+H0JO6acyowtdGJYP/BZzls1GfZOI75JH5uwN7KhQPIdXOZrOWnwDIJNm8FusPara6Q3yzjuFOhQYFyfB84m0jj5GrHFRRSxTq+9c/fBpcaIGqnA+/R9Wk1lt4x9B34m/y1pQ5yTv9MA2gijV4HywnAW+yqVHd6D9VyAiFdDJI9xrj52bVDdC49tmXxjys/ZBUA+GEviLsFBYJg0Y+NggJ+2AvibkGBIFj0Y6OggB/2grj7P9JBzU+zgKoQAAAAAElFTkSuQmCC');
}
.orange {
    color: #FEA217;
}
.categoryArea {
    padding: 14px 8px;
    .categoryItem {
        float: left;
        width: 90px;
        height: 24px;
        line-height: 24px;
        overflow: hidden;
    }
    .categoryItem.active {
        color: #F28500;
    }
}
</style>
